<template>
  <section class="section-product-detail-page bg-grey">
    <div class="container">
      <div class="row m-0">
        <div class="col-12">
          <div class="content py-0">
            <h2 class="section-title page-title h2 text-center text-black f-44 h2-caslon">Our Sustainability</h2>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="section-product-detail-page bg-primary">
    <div class="container">
      <div class="page-content " >

        <div class="content">
          <ContentsTextWithImage
              title="Sustainability Basic Policy"
              image-url="/pages/products/sustainability/01.png"
              :contents="[
              'The measures for sustainability-related issues lead to the highest standards of integrity that the NAGASE Group pursues as its management philosophy and the world in our vision for the future. We acknowledge that continuing corporate activities that contribute to the solution for social and environmental issues enables sustainable growth, and thus we make proactive efforts by developing a policy for sustainability activities.',
            ]"
              is-reverse="true"
              is-white-content="true"
              is-content-small-text="true"
              left-width="39.735%"
              right-width="60.265%"
          />
        </div>

      </div>
    </div>
  </section>

  <section class="section-product-detail-page">
    <div class="container ">
      <div class="page-content">

        <div class="entry-content content" style="color:#7a7a7a">

          <section>
            <div class="content">
              <h2 class="text-black">NAGASE Group Sustainability Basic Policy</h2>
              <h3 class="text-primary">1. Integrity in Business Activities</h3>
              <ol>
                <li>We shall conduct our corporate activities in compliance with all applicable national and regional laws
                  and regulations, and in keeping with societal norms and common sense.
                </li>
                <li>We shall strive to prevent corruption of all kind and maintain healthy and proper relations with our
                  partners and government entities.
                </li>
                <li>
                  We shall strive to provide safe, high-quality products and services, and seek to maintain and improve the
                  value to our customers and partners.
                </li>
                <li>
                  We shall safeguard the benefit to the consumer through maintaining and promoting fair and free
                  competition.
                </li>
                <li>
                  We shall strive toward rigorous management and protection of information about our customers and our
                  company.
                </li>
              </ol>
            </div>
          </section>

          <section>
            <div class="content">
              <h3 class="text-primary">2. Positive Relations with Society</h3>
              <ol>
                <li>We respect human rights and do not permit any sort of discriminatory conduct. We absolutely refuse to
                  accept infringements of human rights such as forced labor or child labor.
                </li>
                <li>We respect the cultures and practices of national and regional societies, and maintain positive
                  relations with society.
                </li>
                <li>
                  We shall strive to ensure health, safety, and appropriate communication with our diverse stakeholders.
                </li>
                <li>
                  We shall constantly pay detailed attention to sustainability among our suppliers, and shall work to make
                  corrections should there be any doubt to their sustainability.
                </li>
                <li>
                  We shall proactively disclose corporate information as appropriate.
                </li>
              </ol>
            </div>
          </section>

          <section>
            <div class="content">
              <h3 class="text-primary">3. Consideration for the Environment</h3>
              <ol>
                <li>We shall comply with national and regional environmental regulations.
                </li>
                <li>We shall contribute to the maintenance of the global environment, including limiting climate change and
                  preventing contamination, promoting reduction in the environmental footprint of our business activities
                  through suppression of greenhouse gas emissions and energy consumption.
                </li>
                <li>
                  We shall, through environmentally-conscious products and services, provide information to our customers
                  about appropriate product usage, recycling, and disposal methods.
                </li>
                <li>
                  We shall contribute broadly to society through environmental conservation activities in various countries
                  and regions.
                </li>
                <li>
                  We recognize the importance of biodiversity and shall strive to conserve ecosystems.
                </li>
              </ol>
              <p class="established text-primary text-end">Established on February 25, 2021</p>

              <h2 class="text-black">The NAGASE Group's materiality (important issues)</h2>
              <p class="text-5a5">The NAGASE Group conducted an external environmental analysis at the time of the
                formulation of ACE 2.0, the mid-term business plan announced in May 2021, and recognized that technological
                innovation, climate change and resource shortages, demographic changes, and industry restructuring are of
                paramount importance to both NAGASE and its stakeholders.</p>
            </div>
          </section>

        </div>
      </div>
    </div>
  </section>
  <!-- PRODUCT DETAIL PAGE -->

  <!-- SECTION GRAPH -->
  <section class="section-graph">
    <div class="container page-container">
      <div class="content pb-0">
        <div class="graph-component">

          <div class="y-asis d-none d-md-block">
            <span>Degree of importance to skateholders</span>
          </div>

          <div class="graph-content row m-0">
            <div class="col-12 col-md-6 p-0">
              <div class="graph-item bg-pink">
                <span class="graph-item-title">Technological <br class="d-none d-md-block d-xl-none" />innovation</span>
                <img src="/pages/products/sustainability/Technological.png" alt="">
                <p class="graph-item-content">The NAGASE Group conducted an external environmental analysis at the
                  time of the formulation of ACE 2.0, the mid-term business plan announced in May 2021, and recognized
                  that technological innovation</p>
              </div>
            </div>
            <div class="col-12 col-md-6 p-0">
              <div class="graph-item bg-grey">
                <span class="graph-item-title">Climate change <br class="d-none d-md-block d-xl-none" />the resource shortages</span>
                <img src="/pages/products/sustainability/Climate.png" alt="">
                <p class="graph-item-content">The NAGASE Group conducted an external environmental analysis at the
                  time of the formulation of ACE 2.0, the mid-term business plan announced in May 2021, and recognized
                  that technological innovation</p>
              </div>
            </div>
            <div class="col-12 col-md-6 p-0">
              <div class="graph-item bg-grey">
                <span class="graph-item-title">Demographic changes</span>
                <img src="/pages/products/sustainability/DemoGraphic.png" alt="">
                <p class="graph-item-content">The NAGASE Group conducted an external environmental analysis at the
                  time of the formulation of ACE 2.0, the mid-term business plan announced in May 2021, and recognized
                  that technological innovation</p>
              </div>
            </div>
            <div class="col-12 col-md-6 p-0">
              <div class="graph-item bg-pink">
                <span class="graph-item-title">Industrial reorganization</span>
                <img src="/pages/products/sustainability/Industrial.png" alt="">
                <p class="graph-item-content">The NAGASE Group conducted an external environmental analysis at the
                  time of the formulation of ACE 2.0, the mid-term business plan announced in May 2021, and recognized
                  that technological innovation</p>
              </div>
            </div>
          </div>

          <div class="x-asis ">
            <span>Degree of importance <br class="d-block d-md-none" />for NAGASE's business</span>
          </div>

        </div>
      </div>
    </div>
  </section>
  <!-- SECTION GRAPH -->
  <section>
    <div class="container">
      <div class="content pt-0">
        <div class="page-content py-0">
          <div class="entry-content">
            <ol>
              <li>Assessed as important matters that produce great change to the respective needs of employees, business
                partners, local communities, consumers, and shareholders.
              </li>
              <li>Assessed as important matters that offer opportunities for new businesses, opportunities for existing
                businesses, threats to existing businesses, and threats to business continuation.
              </li>
            </ol>
            <p class="text-5a5">
              We also identified important issues (materiality) in sustainability based on the value we provide to our
              stakeholders. We will contribute to a sustainable society by addressing the following materiality issues
              through our core business: utilization of diverse human resources, provision of a workplace environment and
              corporate culture; creation of new value through the use of advanced technology; globalization and resolution
              of social and environmental issues; and corporate governance. We will also contribute to the achievement of
              the Sustainable Development Goals (SDGs) * adopted by the United Nations in 2015.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- SECTION TABLE -->
  <section class="section-table mb-5 pb-5" >
    <div class="container">
      <div class="content">

        <table class="table-component-mobile d-xl-none">
          <thead>
            <tr>
              <th class="header bg-black">Employees</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="row">
                  <div class="col-4">
                    <strong>Deliverled Values</strong>
                  </div>
                  <div class="col-8">
                    <p>We also identified important issues (materiality) in sustainability based on the value we provide to our stakeholders. We will contribute to a sustainable society by addressing the following materiality issues through our core business: utilization of diverse human resources, provision of a workplace</p>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="row">
                  <div class="col-4">
                    <strong>Materiality</strong>
                  </div>
                  <div class="col-8">
                    <p>We also identified important issues (materiality) in sustainability based on the value we provide to our stakeholders. We will contribute to a sustainable society by addressing the following materiality issues through our core business: utilization of diverse human resources, provision of a workplace</p>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="row">
                  <div class="col-4">
                    <strong>Related SCGs</strong>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <table class="table-component-mobile d-xl-none">
          <thead>
            <tr>
              <th class="header bg-black">Bussiness Partners</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="row">
                  <div class="col-4">
                    <strong>Deliverled Values</strong>
                  </div>
                  <div class="col-8">
                    <p>We also identified important issues (materiality) in sustainability based on the value we provide to our stakeholders. We will contribute to a sustainable society by addressing the following materiality issues through our core business: utilization of diverse human resources, provision of a workplace</p>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="row">
                  <div class="col-4">
                    <strong>Materiality</strong>
                  </div>
                  <div class="col-8">
                    <p>We also identified important issues (materiality) in sustainability based on the value we provide to our stakeholders. We will contribute to a sustainable society by addressing the following materiality issues through our core business: utilization of diverse human resources, provision of a workplace</p>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="row">
                  <div class="col-4">
                    <strong>Related SCGs</strong>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <table class="table-component-mobile d-xl-none">
          <thead>
            <tr>
              <th class="header bg-black">Society and Consumers</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="row">
                  <div class="col-4">
                    <strong>Deliverled Values</strong>
                  </div>
                  <div class="col-8">
                    <p>We also identified important issues (materiality) in sustainability based on the value we provide to our stakeholders. We will contribute to a sustainable society by addressing the following materiality issues through our core business: utilization of diverse human resources, provision of a workplace</p>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="row">
                  <div class="col-4">
                    <strong>Materiality</strong>
                  </div>
                  <div class="col-8">
                    <p>We also identified important issues (materiality) in sustainability based on the value we provide to our stakeholders. We will contribute to a sustainable society by addressing the following materiality issues through our core business: utilization of diverse human resources, provision of a workplace</p>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="row">
                  <div class="col-4">
                    <strong>Related SCGs</strong>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <table class="table-component-mobile d-xl-none">
          <thead>
            <tr>
              <th class="header bg-black">Share Holders</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="row">
                  <div class="col-4">
                    <strong>Deliverled Values</strong>
                  </div>
                  <div class="col-8">
                    <p>We also identified important issues (materiality) in sustainability based on the value we provide to our stakeholders. We will contribute to a sustainable society by addressing the following materiality issues through our core business: utilization of diverse human resources, provision of a workplace</p>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="row">
                  <div class="col-4">
                    <strong>Materiality</strong>
                  </div>
                  <div class="col-8">
                    <p>We also identified important issues (materiality) in sustainability based on the value we provide to our stakeholders. We will contribute to a sustainable society by addressing the following materiality issues through our core business: utilization of diverse human resources, provision of a workplace</p>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="row">
                  <div class="col-4">
                    <strong>Related SCGs</strong>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <table class="table-component d-none d-xl-block">
          <thead>
            <tr>
              <th></th>
              <th class="header bg-black border-right-white">Deliverled Values</th>
              <th class="header bg-primary border-right-white">Materiality</th>
              <th class="header bg-black">Related SCGs</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="header bg-black border-bottom-white">Employees</td>
              <td>We also identified important issues (materiality) in sustainability based on the value we provide to
                our stakeholders. We will contribute to a sustainable society by addressing the following materiality
                issues through our core business: utilization of diverse human resources, provision of a workplace
              </td>
              <td>We also identified important issues (materiality) in sustainability based on the value we provide to
                our stakeholders. We will contribute to a sustainable society by addressing the following materiality
                issues through our core business: utilization of diverse human resources, provision of a workplace
              </td>
              <td></td>
            </tr>
            <tr>
              <td class="header bg-black border-bottom-white">Bussiness Partners</td>
              <td>We also identified important issues (materiality) in sustainability based on the value we provide to
                our stakeholders. We will contribute to a sustainable society by addressing the following materiality
                issues through our core business: utilization of diverse human resources, provision of a workplace
              </td>
              <td>We also identified important issues (materiality) in sustainability based on the value we provide to
                our stakeholders. We will contribute to a sustainable society by addressing the following materiality
                issues through our core business: utilization of diverse human resources, provision of a workplace
              </td>
              <td></td>
            </tr>
            <tr>
              <td class="header bg-black border-bottom-white">Society and Consumers</td>
              <td>We also identified important issues (materiality) in sustainability based on the value we provide to
                our stakeholders. We will contribute to a sustainable society by addressing the following materiality
                issues through our core business: utilization of diverse human resources, provision of a workplace
              </td>
              <td>We also identified important issues (materiality) in sustainability based on the value we provide to
                our stakeholders. We will contribute to a sustainable society by addressing the following materiality
                issues through our core business: utilization of diverse human resources, provision of a workplace
              </td>
              <td></td>
            </tr>
            <tr>
              <td class="header bg-black">Share Holders</td>
              <td>We also identified important issues (materiality) in sustainability based on the value we provide to
                our stakeholders. We will contribute to a sustainable society by addressing the following materiality
                issues through our core business: utilization of diverse human resources, provision of a workplace
              </td>
              <td>We also identified important issues (materiality) in sustainability based on the value we provide to
                our stakeholders. We will contribute to a sustainable society by addressing the following materiality
                issues through our core business: utilization of diverse human resources, provision of a workplace
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>

      </div>
    </div>
  </section>
  <!-- SECTION TABLE -->
</template>
<script setup lang="ts">
useHead({
  title: 'Sustainability - NAGASE THAILAND Engineering Plastics',
})
</script>

<style scoped>
.page-title {
  padding-bottom: 40px;
}

ol {
  padding: 0;
  margin-bottom: 16px;
  color: #7A7A7A;
}

.text-ol {
  color: #5a5d67;
  margin-left: 30px;
  font-size: 15px;
  line-height: 40px;
  letter-spacing: -0.5px
}

.page-content {
  padding: 60px 0;
}

.entry-content li {
  margin-left: 38px;
  letter-spacing: -0.2px;
}

.entry-content h3 {
  line-height: 28px;
}

.established {
  font-family: 'Roboto', 'Open Sans';
  font-size: 17px;
  font-weight: 300;
  line-height: 17px;
  letter-spacing: 0;

  margin-bottom: 25px;
}

.text-5a5 {
  color: #5A5D67;
}

</style>